module.exports = __webpack_public_path__ + "img/slideImg.13e1a9a7.png";